// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"47dc98f5","455":"ce4581ca","977":"4852d02d"}[chunkId] + ".chunk.js";
};